import React from 'react';
import ErrorImg from 'src/assets/icons/error.png';
import TryAgainButton from 'src/components/TryAgainButton/TryAgainButton';
import { useMediaQuery } from '@material-ui/core';

interface IProps {
  isEnable?: boolean;
}

const GenericError: React.FC<IProps> = ({ isEnable = false }) => {
  const matches = useMediaQuery('(max-width:768px)');
  const isIpadLg = useMediaQuery('(max-width:1024px)');

  const isTablet = matches || isIpadLg;

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <>
      <img
        src={ErrorImg}
        alt="generic-error-picture"
        className="img-error"
        height={isTablet ? '400px' : '491px'}
      />
      <TryAgainButton onClick={handleReload} isEnable={isEnable} />
    </>
  );
};

export default GenericError;
